import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="statement-pricing"
export default class extends Controller {
  static targets = ["unitPrice", "lineTotal", "grandTotal"];
  static values = { currency: { type: String, default: "COP" } };

  updateTotals() {
    let grandTotal = 0;

    this.unitPriceTargets.forEach((input, index) => {
      const unitPrice = parseFloat(input.value) || 0;
      const weight = parseFloat(input.dataset.weight) || 0;
      const lineTotal = weight * unitPrice;
      grandTotal += lineTotal;

      if (this.lineTotalTargets[index]) {
        this.lineTotalTargets[index].textContent = this.formatMoney(lineTotal);
      }
    });

    if (this.hasGrandTotalTarget) {
      this.grandTotalTarget.textContent = this.formatMoney(grandTotal);
    }
  }

  formatMoney(amount) {
    return new Intl.NumberFormat(navigator.language, {
      style: "currency",
      currency: this.currencyValue,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount);
  }
}
